export const getManualRenewalLabel = (allowed?: boolean): string =>
  allowed ? "Manual renewal allowed" : "Manual renewal not allowed";
